import axios from 'helpers/axios';

export const getAccountBalanceTransfers = async ({ queryKey }) => {
    const [, selectType, page, pageSize] = queryKey;
    const { data } = await axios.get('/api/adminapi/accountbalancetransfers/', {
        params: {
            is_processed: selectType === 'processed',
            limit: pageSize,
            offset: page * pageSize,
        }
    });

    return data;
};

export const getAccountBalanceTransferDetail = async ({ queryKey }) => {
    const [, id] = queryKey;
    const { data } = await axios.get(`/api/adminapi/accountbalancetransfers/${id}/`);

    return data;
};

export const confirmAccountBalanceTransfer = async (id: string) => {
    const { data } = await axios.post(`/api/adminapi/accountbalancetransfers/${id}/confirm/`);

    return data;
};
